export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automatización",
    title: "¿Cuándo se envía la información de llegada?",
    desc: "Activa cada evento y decide <strong>cuándo</strong> se envía: cuando <strong>un huésped</strong> completa su registro, o solo cuando <strong>todos</strong> los huéspedes de la reserva completan el registro.",
    loading: "Cargando configuración…",
    welcomeName: "Mensaje de bienvenida",
    welcomeSub: "El mensaje de bienvenida que recibe el huésped justo después de completar su registro.",
    documentName: "Documento firmado de políticas",
    documentSub: "Es el documento que firma el huésped en el proceso de registro. Se lo enviamos en PDF para que lo tenga en su WhatsApp o Email.",
    timingIndividual: "Cuando un huésped completa su registro",
    timingAll: "Cuando todos los huéspedes de la reserva completan el registro",
    timingQuestion: "¿Cuándo se envía?",
    eventOffNote: "Este evento no se enviará automáticamente.",
    infoBox: "Los cambios se guardan automáticamente. La clave de acceso, cuando el alojamiento tiene cerradura inteligente, sigue su propia configuración.",
    loadError: "No se pudo cargar la configuración.",
    saveError: "No se pudo guardar la configuración. Inténtalo de nuevo.",
  },
  checkinProcess: {
    colEmail: "Correo electrónico",
    colSendDate: "Fecha de envío",
    colStatus: "Estado",
    unspecified: "Sin especificar",
    complete: "Completo",
    pending: "Pendiente",
  },
  listBookings: {
    title: "Listado de check-ins",
    subtitle: "Registro de entradas de tus huéspedes",
    accommodation: "Alojamiento",
    all: "Todos",
    from: "Desde",
    to: "Hasta",
    search: "Buscar",
    today: "Hoy",
    noDate: "Sin fecha",
    clear: "Limpiar",
    exporting: "Exportando...",
    exportCheckins: "Exportar",
    ricevutaBtn: "Ricevuta Polizia",
    ricevutaTitle: "Recibo de la policía italiana",
    ricevutaHint: "El recibo oficial de Alloggiati Web con todos los check-ins enviados cada día. Un día baja un PDF; varios, un ZIP con un PDF por día (máximo 31).",
    ricevutaFrom: "Desde",
    ricevutaTo: "Hasta",
    ricevutaAccount: "Cuenta de la policía",
    ricevutaDownload: "Descargar PDF",
    ricevutaDownloading: "Descargando…",
    ricevutaCancel: "Cancelar",
    ricevutaError: "No se pudo descargar el recibo.",
    noAccommodation: "Sin alojamiento",
    noReservation: "Sin reserva",
    travelerReport: "Parte de viajero (Mossos)",
    noRecords: "Sin registros",
    noRecordsFiltered: "No se encontraron registros con los filtros aplicados.",
    noCheckinsTitle: "Aún no hay check-ins registrados",
    noCheckinsSub: "Cuando tus huéspedes completen su check-in, los verás aquí con toda su información.",
    excelSuccess: "Check-ins descargados en Excel",
    excelSuccessTitle: "Exportacion completada",
    excelError: "No pudimos exportar los check-ins",
    errorTitle: "Error",
    listingNotIdentified: "No se pudo identificar el anuncio del check-in",
    comprobanteNotAvailable: "El comprobante aún no está disponible para este check-in",
    comprobanteDownloadError: "No se pudo descargar el comprobante",
  },
  modalFirstCheckin: {
    loading: "Cargando...",
    sendingLinkWait: "Enviando link de check-in, por favor espere...",
    phoneRequired: "Para poder continuar debe ingresar el número de WhatsApp",
    sendingLink: "Enviando link ...",
    almostThere: "Falta poco, por favor espere...",
    sentSuccess: "Enviado con éxito",
    sendError: "Error al enviar el check-in",
    title: "Prueba ahora un proceso de Check-in con tu propio teléfono",
    enterWhatsapp: "Introduce tu número de WhatsApp",
    invalidNumber: `Número inválido. Asegúrate de incluir el prefijo "+".`,
    skip: "Omitir",
    sendFirstCheckin: "Enviar tu primer check-in",
    sendCheckin: "Enviar check-in",
  },
  tableRetriveCheckinPending: {
    colEmail: "Correo electrónico",
    colSendDate: "Fecha de envío",
    colStatus: "Estado",
    unspecified: "Sin especificar",
    complete: "Completo",
    pending: "Pendiente",
    emptyMessage: "Aún no tiene check-ins en proceso",
  },
  rerservationModal: {
    night: "noche",
    nights: "noches",
    minStayBanner: "El rango seleccionado tiene una restricción de estancia mínima de {count} {nights} (regla OTA). Noches seleccionadas: {selected}.",
    freeUnits: "Unidades libres: {count}",
    noAvailabilityDetailed: "Sin disponibilidad para estas fechas. {details}",
    noAvailability: "Sin disponibilidad para estas fechas.",
    hotelAvailabilityError: "No se pudo validar la disponibilidad (hotel).",
    minStayWarning: "Para el día de llegada se requiere mínimo {count} noches. Has seleccionado {selected}.",
    notEnoughAvailability: "No hay disponibilidad suficiente. Unidades libres: {count}.",
    noAvailabilityDates: "No hay disponibilidad para las fechas seleccionadas.",
    departureAfterArrival: "La salida debe ser posterior a la llegada.",
    close: "Cerrar",
    noMatches: "Sin coincidencias",
    noAccommodations: "No hay alojamientos",
    searchingGuests: "Buscando huéspedes...",
    noName: "Sin nombre",
    priceLocked: "No se puede modificar el precio de la reserva.",
    otaMoveHint: "Puedes moverla a otro alojamiento del mismo anuncio; se avisa al canal.",
    otaMoveHintCuenta: "Puedes moverla a cualquiera de tus alojamientos. Si es del mismo anuncio, se avisa al canal.",
    otaRelocateNote: "Es otro anuncio: se mueve en WACheckin, pero el canal la seguirá teniendo en el alojamiento donde se vendió. Sus cambios y su cancelación te seguirán llegando.",
    extrasTitle: "Otras opciones",
    extrasSub: "Marca lo que cobras y el descuento que aplicas",
    quoteTitle: "Lo que cobra tu reserva directa",
    quoteHint: "Marca lo que quieras cobrar en esta reserva. Las noches van siempre.",
    quoteOptions: "1 por marcar | {count} por marcar",
    quoteNoExtras: "Este alojamiento no tiene limpieza ni cargos configurados en su reserva directa.",
    quoteStay: "Estancia · {count} noche | Estancia · {count} noches",
    quoteExtraGuest: "Huésped extra | {count} huéspedes extra",
    quoteDiscount: "Descuentos y promociones",
    quoteOccupancyDiscount: "Descuento por ocupación",
    quoteCleaning: "Gastos de limpieza",
    quoteTotal: "Total",
    quoteUse: "Usar este precio",
    quoteNoRate: "Sin tarifa para esas fechas: escribe el precio a mano.",
    quoteLinePrice: "Precio de este alojamiento",
    unitsAdd: "Añadir otro alojamiento del anuncio…",
    unitsGuests: "Huéspedes en este alojamiento",
    unitsRemove: "Quitar de la reserva",
    unitsGroupError: "No se pudo crear la reserva de varios alojamientos.",
    resendTitle: "Reenviar mensaje de confirmación",
    resendSub: "Vuelve a enviar la plantilla de confirmación al huésped.",
    resendNote: "Al modificar la reserva se <strong>reenviará la plantilla de confirmación</strong> de esta reserva.",
    saving: "Guardando...",
  },
};
